export default {
  'Your win': 'Kazancınız',
  'Select skins that you want to take': 'Almak istediğiniz tasarımları seçin',
  'By price': 'Fiyata göre',
  '(Autotrade will receive after 10 minutes)': '(Ototakas 10 dakika sonra teslim alacak)',
  ACCEPT: 'Onayla',
  'SELECT ALL': 'SELECT ALL',
};
